module.exports = __webpack_public_path__ + "static/media/card-project6.cdb05aa3.jpg";